import {
  Building2,
  MapPin,
  Train,
  Link2,
  ShoppingBag,
  KeyRound,
  ShieldCheck,
  ChartNoAxesCombined,
} from "lucide-react";

export const skyOneHighlights = [
  {
    title: "Freehold Residence",
    description: "Freehold tenure in Johor Bahru’s prestigious Zone A growth corridor.",
    icon: Building2,
  },
  {
    title: "440m to JB Sentral",
    description: "Walking distance to JB Sentral.",
    icon: MapPin,
  },
  {
    title: "300m to RTS Link",
    description: "Unbeatable Connectivity to Singapore. Just ~300 m (about a 3-minute walk) from the RTS Bukit Chagar",
    icon: Train,
  },
  {
    title: "Link Bridge to JB Sentral",
    description:
      "Proposed direct connection* linked to the existing link bridge to JB Sentral.",
    icon: Link2,
  },
  {
    title: "Retail convenience",
    description: "Retail convenience ready below apartment.",
    icon: ShoppingBag,
  },
  {
    title: "Dual & triple-key Concept",
    description: "Accommodate different family living arrangements — all boosting rental yield potential.",
    icon: KeyRound,
  },
  {
    title: "Trusted Developer",
    description: "Built by an award-winning and reliable development team.",
    icon: ShieldCheck,
  },
  {
    title: "Strong Investment & Rental Demand Potential",
    description:
      "Strategically located to support long-term value growth and rental returns.",
    icon: ChartNoAxesCombined,
  },
];